Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var coreComponentsShared = require('../../../shared');
var Context = require('../../Context.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"component":"system-message__component_1m1dv","column":"system-message__column_1m1dv","row":"system-message__row_1m1dv","stretch":"system-message__stretch_1m1dv"};
require('./index.css');

var DEFAULT_DESKTOP_PADDING = { top: 24 };
var DEFAULT_MOBILE_PADDING = { top: 16 };
var Controls = function (_a) {
    var _b;
    var directionProp = _a.direction, children = _a.children, className = _a.className, paddingProp = _a.padding;
    var _c = React.useContext(Context.SystemMessageContext), dataTestId = _c.dataTestId, view = _c.view;
    var defaultDirection = view === 'mobile' ? 'column' : 'row';
    var direction = directionProp || defaultDirection;
    var isMultipleElements = React__default.default.Children.toArray(children).length > 1;
    var isColumn = isMultipleElements && direction === 'column';
    var padding = paddingProp !== null && paddingProp !== void 0 ? paddingProp : (view === 'mobile' ? DEFAULT_MOBILE_PADDING : DEFAULT_DESKTOP_PADDING);
    return (React__default.default.createElement("div", { className: cn__default.default(styles.component, className, (_b = {},
            _b[styles.row] = !isColumn,
            _b[styles.column] = isColumn,
            _b[styles.stretch] = isMultipleElements || view === 'mobile',
            _b)), "data-test-id": coreComponentsShared.getDataTestId(dataTestId, 'controls'), style: coreComponentsShared.createPaddingStyle(padding) }, children));
};
Controls.displayName = 'Controls';

exports.Controls = Controls;
